import {createI18n} from 'vue-i18n'

// 静态导入所有语言文件
import enUS from './locales/en-US.json'
import thTHA from './locales/th-THA.json'
import myMYS from './locales/my-MYS.json'
import idIDN from './locales/id-IDN.json'
import msMY from './locales/ms-MY.json'
import viVN from './locales/vi-VN.json'
import ptBR from './locales/pt-BR.json'
import esMX from './locales/es-MX.json'
import zhCN from './locales/zh-CN.json'
import arAR from './locales/ar-AR.json'

const i18n = createI18n({
    legacy: true, // 必须设置为 false 才能使用 Composition API
    locale: localStorage.getItem('lang') || 'en-US', // 默认语言
    messages: {
        'en-US': enUS,
        'th-THA': thTHA,
        'my-MYS': myMYS,
        'id-IDN': idIDN,
        'ms-MY': msMY,
        'vi-VN': viVN,
        'pt-BR': ptBR,
        'es-MX': esMX,
        'zh-CN': zhCN,
        'ar-AR': arAR,
    },
    fallbackLocale: 'en-US', // 回退语言
})

export default i18n